import React from "react";
import { Div, Text, Row, Col, Image, StyleReset } from "atomize";
import { Input, Button, Icon, Anchor } from "atomize/dist";
import CustomContainer from "./CustomContainer";
import FooterButton from "./FooterButton";
import WebsiteContainer from "./WebsiteContainer";
import AnimateLink from "./AnimateLink";
import InnerHTML from "../../utilities/innerHtml";
import { updateActiveCampaignForm } from "../../utilities/helpers";
var emailBlackForm = ``;

const Footer = ({ contentfulFooter, contentfulGlobalConfig }) => {
  return (
    <>
      <Div
        bg="black300"
        border={{
          y: "1px solid",
        }}
        borderColor="border"
        m={{
          t: { xs: "1rem", md: "5.5rem" },
        }}
        fontFamily="secondary"
      >
        {/* Footer Menu */}
        <WebsiteContainer>
          <CustomContainer p={{ x: { xs: "0", sm: "1.5rem" } }}>
            <Row m={{ x: { xs: "0", sm: "-0.5rem" } }}>
              <Col
                size={{ xs: "6", lg: "4" }}
                order={{ xs: 2, lg: 1 }}
                border={{ l: { xs: "1px solid", md: "none" } }}
                borderColor="border"
                p={{ x: { xs: "0", md: "0.5rem" } }}
              >
                <Div
                  p={{ y: "2rem" }}
                  d="flex"
                  flexDir="column"
                  h="100%"
                  justify="space-evenly"
                >
                  {contentfulFooter.menu.slice(0, 2).map(item => (
                    <Div
                      textSize="subheader2"
                      textWeight="600"
                      d="flex"
                      flexDir="column"
                      align="center"
                      p={{
                        y: { xs: "1.5rem", md: "1.5rem" },
                      }}
                    >
                      <AnimateLink to={item.link}>
                        <Div
                          d="block"
                          textColor="white"
                          textWeight="600"
                          hoverTextColor="gray300"
                        >
                          {item.label}
                        </Div>
                      </AnimateLink>
                    </Div>
                  ))}
                </Div>
              </Col>
              <Col
                size={{ xs: "12", lg: "4" }}
                order={{ xs: 3, lg: 2 }}
                p={{ x: { xs: "0", md: "0.5rem" } }}
                border={{ t: { xs: "1px solid", md: "none" } }}
                borderColor="border"
              >
                <Div
                  d="flex"
                  flexDir="column"
                  align="center"
                  p={{
                    t: "3rem",
                    b: "2rem",
                  }}
                  h="100%"
                >
                  <Div
                    textSize="subheader2"
                    textWeight="600"
                    p={{
                      b: "1.2rem",
                    }}
                  >
                    Solutions
                  </Div>
                  <Div d="flex" flexDir="column" align="center">
                    {contentfulFooter.solutions.map(solution => {
                      return (
                        <Div
                          p={{
                            b: { xs: "0.75rem" },
                          }}
                        >
                          <AnimateLink to={solution.link}>
                            <Div
                              d="block"
                              textSize="caption1"
                              textWeight="200"
                              textColor="white"
                              hoverTextColor="gray300"
                            >
                              {solution.label}
                            </Div>
                          </AnimateLink>
                        </Div>
                      );
                    })}
                  </Div>
                </Div>
              </Col>
              <Col
                size={{ xs: "6", lg: "4" }}
                order={{ xs: 1, lg: 3 }}
                p={{ x: { xs: "0", md: "0.5rem" } }}
              >
                <Div
                  p={{ y: "2rem" }}
                  d="flex"
                  flexDir="column"
                  h="100%"
                  justify="space-evenly"
                >
                  {contentfulFooter.menu.slice(2, 4).map(item => (
                    <Div
                      textSize="subheader2"
                      textWeight="600"
                      d="flex"
                      flexDir="column"
                      align="center"
                      p={{
                        y: { xs: "1.5rem", md: "1.5rem" },
                      }}
                    >
                      <AnimateLink to={item.link}>
                        <Div
                          d="block"
                          textColor="white"
                          textWeight="600"
                          hoverTextColor="gray300"
                        >
                          {item.label}
                        </Div>
                      </AnimateLink>
                    </Div>
                  ))}
                </Div>
              </Col>
            </Row>
          </CustomContainer>
        </WebsiteContainer>
      </Div>
      <Div bg="black300" p={{ y: { xs: "4rem", lg: "2.4rem " } }}>
        <WebsiteContainer>
          <CustomContainer p={{ x: { xs: "0", md: "2.5rem" } }}>
            <Div
              d="flex"
              align="center"
              flexDir="column"
              // m={{ y: { xs: "4rem", lg: "0" } }}
            >
              <Text
                textAlign="center"
                p={{
                  // t: { xs: "1rem", md: "1.5rem" },
                  b: { xs: "1rem", md: "1rem" },
                }}
                textColor="primary"
                fontFamily="secondary"
                textSize="caption2"
                textWeight="500"
                maxW="19rem"
                m="aut0"
              >
                Subscribe to our DTC Podcast and join our community to learn
                from the best ecommerce founders
              </Text>
              <Div w="100%" p={{ x: "25px" }}>
                {typeof window !== "undefined" && (
                  <InnerHTML
                    html={updateActiveCampaignForm(
                      contentfulGlobalConfig.footerForm.footerForm
                    )}
                  />
                )}
              </Div>
            </Div>

            {/* Footer Links */}
            <Div
              d="flex"
              justify="space-between"
              align="center"
              // p={{
              //   y: { xs: "1rem", md: "2rem" },
              // }}
              fontFamily="secondary"
              textSize="tiny"
              flexDir={{ xs: "column", lg: "row" }}
            >
              <Anchor
                href={contentfulFooter.logoLink}
                p={{ b: { xs: "1rem", lg: "0" } }}
              >
                <Image
                  alt={contentfulFooter.alt && contentfulFooter.alt}
                  src="/images/logo-white.svg"
                  maxW="4.3rem"
                />
              </Anchor>
              {contentfulFooter.links.map(link => (
                <Div p={{ b: { xs: "1rem", lg: "0" } }}>
                  {link.link === null ? (
                    <Div
                      textTransform="uppercase"
                      textColor="gray500"
                      hoverTextColor="gray300"
                    >
                      {link.label}
                    </Div>
                  ) : (
                    <Anchor
                      textTransform="uppercase"
                      textColor="gray500"
                      hoverTextColor="gray300"
                      href={link.link}
                    >
                      {link.label}
                    </Anchor>
                  )}
                </Div>
              ))}
              <Anchor href={contentfulFooter.instagramLink}>
                <Icon
                  name="Instagram"
                  m={{ t: { xs: "0.49rem", md: "0" } }}
                  size={{ xs: "40px", md: "20px" }}
                  color="gray500"
                  hoverColor="gray300"
                />
              </Anchor>
            </Div>
          </CustomContainer>
        </WebsiteContainer>
      </Div>
    </>
  );
};

export default Footer;
